function parentByLevel(target, level)
{
	while (level-- > 0 && target)
	{
		target = target.parentNode;
	}

	return target;
}

function move(article, items, isPinned)
{
	const place = items.querySelector('.item-pinned:last-child');
	
	article.classList.toggle('item-pinned', isPinned);
}

const pin = (link, target) =>
{
  const data = new FormData();

  if (target.dataset.token) {
    data.append("token", target.dataset.token);
  }

	fetch(link, {
		method: "POST",
    body: data
	})
	.then(response => response.json())
	.then(json => {
		if (json.success == 1)
		{
			window.location.reload();
		}
		else
		{
			console.error("Что-то пошло не так");
		}
	});
}

export { pin };